import { useAutosave } from "./saving/useAutosave";
import { useEntryNavigation } from "./saving/useEntryNavigation";
import { useEntryParams } from "./saving/useEntryParams";

interface UseV2SavingOptions {
  enableAutosave?: boolean;
  autosaveDelayMs?: number;
}

export const useV2AutoSave = (options: UseV2SavingOptions = {}) => {
  const params = useEntryParams();
  const navigation = useEntryNavigation(params.logbookId, params.entryIdType);

  const { autoSave, isSaving: isAutoSaving } = useAutosave(
    params,
    navigation,
    options,
  );

  return {
    autoSave,
    isSaving: isAutoSaving,
  };
};
